/* Classic BR: buy box simples. Galeria filtra pela cor; packs (tiers) ou "+ Adicionar outra peça". */
(function(){
document.querySelectorAll('.cbr-pdp[data-cbr-simple]').forEach(function(root){
  if(root.dataset.cbrInit) return; root.dataset.cbrInit='1';
  root.querySelectorAll('button:not([type])').forEach(function(b){ b.type='button'; });
  var variants=[];
  try{ variants=JSON.parse(root.querySelector('script[data-variants]').textContent); }catch(e){}

  /* ---------- galeria ---------- */
  var thumbs=root.querySelectorAll('.cbr-thumb'), slides=root.querySelectorAll('.cbr-slide'), cur=0;
  var dots=root.querySelectorAll('.cbr-gal__dot');
  function visiveis(){ var a=[]; slides.forEach(function(s){ if(!s.classList.contains('is-hidden')) a.push(+s.dataset.idx); }); return a.length?a:[0]; }
  function carrega(i){ var s=slides[i]; if(!s) return; s.querySelectorAll('img[loading="lazy"]').forEach(function(im){ im.loading='eager'; }); }
  function showSlide(i){ if(!slides.length) return; cur=(i+slides.length)%slides.length; carrega(cur);
    slides.forEach(function(s){s.classList.toggle('is-active', +s.dataset.idx===cur);});
    thumbs.forEach(function(t){t.classList.toggle('is-active', +t.dataset.idx===cur);});
    dots.forEach(function(d){ d.classList.toggle('is-active', +d.dataset.idx===cur); }); }
  function passo(dir){ var vis=visiveis(); var p=vis.indexOf(cur); if(p<0) p=0; p=(p+dir+vis.length)%vis.length; showSlide(vis[p]); }
  var corAtual=null;
  function filtraCor(cor){
    var c=(cor||'').toLowerCase().trim(), algum=false;
    if(c){ slides.forEach(function(s){ if((s.dataset.key||'').indexOf(c)>-1) algum=true; }); }
    [slides,thumbs,dots].forEach(function(lista){ lista.forEach(function(el){
      var s=slides[+el.dataset.idx], key=(s && s.dataset.key)||'';
      el.classList.toggle('is-hidden', algum && key.indexOf(c)===-1); }); });
    var vis=visiveis(); vis.slice(0,3).forEach(carrega); showSlide(vis[0]);
  }
  thumbs.forEach(function(t){ t.addEventListener('click',function(){ showSlide(+t.dataset.idx); }); });
  var pv=root.querySelector('.cbr-gal__prev'), nx=root.querySelector('.cbr-gal__next');
  if(pv) pv.addEventListener('click',function(){ passo(-1); });
  if(nx) nx.addEventListener('click',function(){ passo(1); });
  root.addEventListener('click',function(e){ var d=e.target.closest('.cbr-gal__dot'); if(d) showSlide(+d.dataset.idx); });
  var stage=root.querySelector('.cbr-gal__stage');
  if(stage){ var sx=0,sy=0,tk=false;
    stage.addEventListener('touchstart',function(e){var t=e.changedTouches[0];sx=t.clientX;sy=t.clientY;tk=true;},{passive:true});
    stage.addEventListener('touchend',function(e){ if(!tk)return; tk=false; var t=e.changedTouches[0],dx=t.clientX-sx,dy=t.clientY-sy;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)) passo(dx<0?1:-1); },{passive:true}); }

  /* ---------- opções ---------- */
  var btns=root.querySelectorAll('.cbr-size');
  var vidInput=root.querySelector('.cbr-vid'), qtyIn=root.querySelector('.cbr-qty');
  var atc=root.querySelector('.cbr-atc'), form=root.querySelector('.cbr-form');
  var elNow=root.querySelector('.cbr-price__now'), elWas=root.querySelector('.cbr-price__was'), elPer=root.querySelector('.cbr-price__per');
  if(window.__cbrFreteSelecao){ var pb0=root.querySelector('.cbr-price'); window.__cbrFreteSelecao(parseInt((pb0&&pb0.dataset.unitPrice)||0,10)); }
  var nOpts=0, optVals={}, optNames={};
  btns.forEach(function(b){ var p=+b.dataset.pos||1; nOpts=Math.max(nOpts,p); (optVals[p]=optVals[p]||[]).push(b.dataset.value); });
  for(var p0=1;p0<=nOpts;p0++){ var lb=root.querySelector('[data-optlabel="'+p0+'"]'); optNames[p0]=lb?lb.parentElement.firstChild.textContent.replace(':','').trim():('Opção '+p0); }
  var corPos=+root.dataset.colorPos||0;
  var escolha={};
  function money(c){ try{ return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(c/100); }catch(e){ return 'R$ '+(c/100).toFixed(2).replace('.',','); } }
  function acha(sel){ if(Object.keys(sel).length<nOpts) return null;
    return variants.filter(function(v){ for(var p=1;p<=nOpts;p++){ if(v.options[p-1]!==sel[p]) return false; } return true; })[0]||null; }
  function disponivel(pos,val){ return variants.some(function(v){
      if(v.options[pos-1]!==val) return false;
      for(var p=1;p<=nOpts;p++){ if(p!==pos && escolha[p] && v.options[p-1]!==escolha[p]) return false; }
      return v.available; }); }

  /* ---------- peças extras (packs ou "+ Adicionar outra peça") ---------- */
  var tiers=root.querySelectorAll('.cbr-tier'), qtyLbl=root.querySelector('.cbr-qty-label'), note=root.querySelector('.cbr-tier-note');
  var multi=root.querySelector('[data-cbr-multi]');
  var tq=1, toff=0, tcupom='', packBox=null, packSel=[];
  function linhas(removivel){
    var h='';
    packSel.forEach(function(sel,i){
      h+='<div class="cbr-pack-row" data-i="'+i+'"><span class="cbr-pack-row__n">Peça '+(i+2)+'</span>';
      for(var p=1;p<=nOpts;p++){
        h+='<select data-i="'+i+'" data-pos="'+p+'" aria-label="'+optNames[p]+' da peça '+(i+2)+'">';
        (optVals[p]||[]).forEach(function(val){ h+='<option value="'+val.replace(/"/g,'&quot;')+'"'+(sel[p]===val?' selected':'')+'>'+val+'</option>'; });
        h+='</select>';
      }
      if(removivel) h+='<button type="button" class="cbr-pack-row__x" data-rm="'+i+'" aria-label="Remover peça '+(i+2)+'">×</button>';
      h+='</div>';
    });
    return h;
  }
  function onChange(e){ var s=e.target.closest('select'); if(!s) return; packSel[+s.dataset.i][+s.dataset.pos]=s.value; pinta(); }
  if(multi){
    var listEl=multi.querySelector('.cbr-multi__list'), tipEl=multi.querySelector('.cbr-pack-rows__tip'), addBtn=multi.querySelector('.cbr-multi__add');
    packBox=multi;
    var redesenha=function(){ tq=1+packSel.length; listEl.innerHTML=linhas(true); if(tipEl) tipEl.hidden=!packSel.length; pinta(); };
    multi.addEventListener('change',onChange);
    multi.addEventListener('click',function(e){ var x=e.target.closest('[data-rm]'); if(!x) return; packSel.splice(+x.dataset.rm,1); redesenha(); });
    if(addBtn) addBtn.addEventListener('click',function(){ packSel.push(Object.assign({},escolha)); redesenha(); });
  }
  function montaPack(){
    if(!tiers.length) return;
    if(!packBox){ packBox=document.createElement('div'); packBox.className='cbr-pack-rows'; var pr=root.querySelector('.cbr-price'); pr.parentNode.insertBefore(packBox, pr);
      packBox.addEventListener('change',onChange); }
    if(tq<=1){ packBox.hidden=true; packSel=[]; return; }
    while(packSel.length<tq-1) packSel.push(Object.assign({},escolha));
    packSel.length=tq-1;
    packBox.innerHTML='<p class="cbr-pack-rows__tip">Peça 1: a cor e o tamanho escolhidos acima. Escolha as outras:</p>'+linhas(false);
    packBox.hidden=false;
  }
  tiers.forEach(function(t){ t.addEventListener('click',function(){
    tiers.forEach(function(x){ x.classList.toggle('is-active', x===t); });
    tq=parseInt(t.dataset.qty,10)||1; toff=parseInt(t.dataset.off,10)||0; tcupom=t.dataset.cupom||'';
    if(qtyIn) qtyIn.value=1;
    if(qtyLbl) qtyLbl.textContent=tq;
    if(note){ if(tcupom){ note.hidden=false; note.innerHTML='Use o cupom <b>'+tcupom+'</b> no checkout para garantir o desconto.'; } else { note.hidden=true; } }
    montaPack(); pinta();
  }); });

  function pinta(){
    btns.forEach(function(b){ var pos=+b.dataset.pos, val=b.dataset.value;
      b.classList.toggle('is-active', escolha[pos]===val); b.classList.toggle('is-off', !disponivel(pos,val)); });
    root.querySelectorAll('[data-optlabel]').forEach(function(el){ var pos=+el.dataset.optlabel; el.textContent=escolha[pos]||'Escolha'; });
    var mudouCor=false;
    if(corPos && escolha[corPos] && escolha[corPos]!==corAtual){ corAtual=escolha[corPos]; filtraCor(corAtual); mudouCor=true; }
    var v=acha(escolha);
    if(!v){ if(atc){ atc.disabled=true; atc.textContent=atc.dataset.needSize; } return; }
    var soma=v.price, ok=v.available;
    if(tq>1 && packBox){ packSel.forEach(function(sel,i){ var pv2=acha(sel); var row=packBox.querySelector('.cbr-pack-row[data-i="'+i+'"]');
      var bom=!!(pv2 && pv2.available); if(row) row.classList.toggle('is-off',!bom); if(!bom) ok=false; soma+=pv2?pv2.price:v.price; }); }
    var total=soma-toff;
    if(vidInput) vidInput.value=v.id;
    if(elNow) elNow.textContent=money(total);
    if(window.__cbrFreteSelecao) window.__cbrFreteSelecao(total);
    if(elWas){ if(tq>1 && toff>0) elWas.textContent=money(soma); else elWas.textContent=(tq<=1 && v.compare_at_price>v.price)?money(v.compare_at_price):''; }
    if(elPer) elPer.textContent = tq>1 ? (tq+' peças') : '';
    var st=root.querySelector('.cbr-sticky-atc__price'); if(st) st.textContent=money(total);
    if(atc){ atc.disabled=!ok; atc.textContent=ok?(tq>1?'Adicionar '+tq+' peças ao carrinho':atc.dataset.default):(tq>1&&v.available?'Uma das peças está esgotada':atc.dataset.soldOut); }
    if(!corPos && !mudouCor && v.featured_media){ var idx=null;
      slides.forEach(function(s,i){ if(idx===null && s.querySelector('img') && v.featured_media.preview_image &&
        (s.querySelector('img').src||'').indexOf((v.featured_media.preview_image.src||'').split('?')[0].split('/').pop())>-1) idx=i; });
      if(idx!==null) showSlide(idx); }
  }
  btns.forEach(function(b){ b.addEventListener('click',function(){
    if(b.classList.contains('is-off')) return; escolha[+b.dataset.pos]=b.dataset.value; pinta(); }); });

  /* várias peças: adiciona todas de uma vez */
  if(form){ form.addEventListener('submit',function(e){
    if(tq<=1) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var v=acha(escolha); if(!v) return;
    var map={}; map[v.id]=1;
    packSel.forEach(function(sel){ var pv2=acha(sel); if(pv2) map[pv2.id]=(map[pv2.id]||0)+1; });
    var items=Object.keys(map).map(function(id){ return {id:parseInt(id,10), quantity:map[id]}; });
    if(atc){ atc.disabled=true; atc.textContent='Adicionando...'; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) return r.json().then(function(j){throw j;}); return r.json(); })
      .then(function(){ window.location.href='/cart'; })
      .catch(function(err){ alert((err&&err.description)?err.description:'Não foi possível adicionar as peças.'); pinta(); });
  }, true); }

  (function(){ var v0=variants.filter(function(v){return v.available;})[0]||variants[0];
    if(v0){ for(var p=1;p<=nOpts;p++){ escolha[p]=v0.options[p-1]; } } pinta(); })();

  /* ---------- complete o look ---------- */
  root.querySelectorAll('.cbr-look-add').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var item=btn.closest('.cbr-look__item'), sel=item?item.querySelector('.cbr-look__size'):null, vid=sel?sel.value:btn.dataset.vid;
      if(!vid){ window.location.href=btn.dataset.url; return; }
      var txt=btn.textContent; btn.disabled=true; btn.textContent='…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:1,properties:{'_addon':'look'}}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(j){throw j;}); return r.json(); })
        .then(function(){ btn.textContent='✓'; btn.classList.add('is-added');
          setTimeout(function(){ btn.textContent=txt; btn.disabled=false; btn.classList.remove('is-added'); },1800); })
        .catch(function(err){ btn.textContent=txt; btn.disabled=false; alert((err&&err.description)?err.description:'Não foi possível adicionar.'); });
    });
  });

  /* ---------- Tabela de medidas ---------- */
  var guideModal=root.querySelector('[data-modal="guide"]');
  if(guideModal){
    var hlSize=function(){ var active=root.querySelector('.cbr-size.is-active'); var val=active?(active.dataset.value||'').trim():null;
      guideModal.querySelectorAll('.cbr-mt__table tbody tr').forEach(function(tr){ tr.classList.toggle('is-hl', !!val && (tr.dataset.size||'').trim()===val); }); };
    var openGuide=function(){ guideModal.hidden=false; document.body.style.overflow='hidden'; hlSize(); };
    var closeGuide=function(){ guideModal.hidden=true; document.body.style.overflow=''; };
    root.querySelectorAll('.cbr-guide-open').forEach(function(b){ b.addEventListener('click', openGuide); });
    guideModal.addEventListener('click', function(e){ if(e.target===guideModal || e.target.hasAttribute('data-close')) closeGuide(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !guideModal.hidden) closeGuide(); });
  }

  /* ---------- ATC sticky ---------- */
  var sticky=root.querySelector('.cbr-sticky-atc');
  if(sticky && atc){ var sBtn=sticky.querySelector('.cbr-sticky-atc__btn');
    new IntersectionObserver(function(es){ es.forEach(function(en){ sticky.classList.toggle('is-on', !en.isIntersecting); }); },{rootMargin:'0px 0px -60px 0px'}).observe(atc);
    if(sBtn) sBtn.addEventListener('click',function(){ if(!atc.disabled){ atc.click(); } else { atc.scrollIntoView({behavior:'smooth',block:'center'}); } }); }
});
})();